class CtaCarousel extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.carouselEl || window.BAO.utils.prefersReducedMotion()) return
    this.setGrabbable()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.slidesEl || window.BAO.utils.prefersReducedMotion()) return
    this.listeners.add(document, 'scroll', this.handleScroll.bind(this))

    this.handleResize = this.handleResize.bind(this)
    this.listeners.add(
      window,
      'resize',
      window.BAO.utils.debounce(event => {
        this.handleResize(event)
      }, 500),
    )
  }

  setGrabbable () {
    this.carouselEl.toggleAttribute(
      'disable-grab',
      window.BAO.MediaBreakpoints.isMd,
    )
  }

  handleScroll () {
    if (!window.BAO.MediaBreakpoints.isMd) return

    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  handleResize () {
    this.setGrabbable()
    this.carouselEl.scrollLeft = 0
    this.slidesEl.removeAttribute('style')
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.moveCarousel.bind(this))

    this.isTicking = true
  }

  moveCarousel () {
    this.isTicking = false

    const animationDuration = 0.4

    const distanceToScrollPx = this.slidesEl.offsetWidth - window.innerWidth
    const distanceToScrollVw = (distanceToScrollPx / window.innerWidth) * 100

    const startPoint = window.BAO.utils.getOffsetTop(this)
    const endPoint =
      window.BAO.utils.getOffsetTop(this) +
      this.offsetHeight -
      this.slidesEl.offsetHeight

    if (this.lastKnownY <= startPoint) {
      setTimeout(() => {
        this.slidesEl.style.transform = 'translate3d(0vw, 0px, 0px)'
      }, animationDuration)

      return
    }

    if (this.lastKnownY > endPoint) {
      setTimeout(() => {
        this.slidesEl.style.transform = `translate3d(-${distanceToScrollVw}vw, 0px, 0px)`
      }, animationDuration)

      return
    }

    const totalScrollAmount = endPoint - startPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - startPoint) / totalScrollAmount

    const transformAmountX = distanceToScrollVw * scrollYAsAPercentageOfJourney

    setTimeout(() => {
      this.slidesEl.style.transform = `translate3d(-${transformAmountX}vw, 0px, 0px)`
    }, animationDuration)
  }

  get carouselEl () {
    return this.slidesEl?.parentNode
  }

  get slidesEl () {
    return this.els?.slides?.element
  }
}

if (!customElements.get('cta-carousel')) {
  customElements.define('cta-carousel', CtaCarousel)
}
